const awsmobile = {
"aws_project_region": "us-east-1",
"aws_cognito_region": "us-east-1",
"aws_user_pools_id": "us-east-1_XSvPqxizM",
"aws_user_pools_web_client_id": "72dqf0ukaqt4j02uk35kn381t9",
"oauth": {"domain": "confirm-prod.emerge9.com.auth.us-east-1.amazoncognito.com"}}
export default awsmobile
